import { Check, Minus } from "lucide-react";
import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { EXCLUSIONS, INCLUSIONS } from "./data";

export default function Inclusions() {
  return (
    <section id="details" data-testid="inclusions-section" className="bg-ivory">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow center>All taken care of</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="What&rsquo;s" accent="Included" center className="mt-7" />
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mx-auto mt-7 h-px w-16 bg-saffron/50" aria-hidden="true" />
        </Reveal>

        <div className="mx-auto mt-14 grid max-w-4xl gap-x-12 gap-y-5 md:grid-cols-2">
          {INCLUSIONS.map((item, i) => (
            <Reveal key={item} delay={i * 0.05}>
              <div data-testid={`inclusion-item-${i}`} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-saffron/15">
                  <Check className="h-3.5 w-3.5 text-saffron" strokeWidth={2} />
                </span>
                <p className="text-[15px] leading-relaxed text-ink/85">{item}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-24 border-t border-ink/10 pt-20">
          <Reveal>
            <Eyebrow center>Please note</Eyebrow>
          </Reveal>
          <Reveal delay={0.12}>
            <SectionTitle before="What&rsquo;s" accent="Excluded" center className="mt-7" />
          </Reveal>

          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {EXCLUSIONS.map((item, i) => (
              <Reveal
                key={item.title}
                delay={i * 0.06}
                className="border border-ink/10 bg-cream p-7 transition-colors duration-500 hover:border-saffron/40"
              >
                <div data-testid={`exclusion-item-${i}`}>
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ink/5">
                    <Minus className="h-4 w-4 text-ink/60" strokeWidth={1.6} />
                  </span>
                  <h3 className="mt-5 font-serif text-xl font-light text-ink">{item.title}</h3>
                  <p className="mt-2 text-[13px] leading-[1.8] text-fog">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
